var map = {
	"./accionaenergia.svg": 28937,
	"./accionaenergia2.svg": 71193,
	"./canal.svg": 28681,
	"./correos.jpg": 73001,
	"./correos.svg": 25125,
	"./demo.svg": 88025,
	"./eiffage.svg": 55215,
	"./hipoges.svg": 59593,
	"./lyntia.png": 93227,
	"./lyntia.svg": 98897,
	"./ohla.svg": 50972,
	"./pacsa.svg": 9092,
	"./quironocr.svg": 26328,
	"./redes.svg": 11425,
	"./ree.svg": 35648,
	"./renfe.svg": 94192,
	"./tee.svg": 87578,
	"./ufgas.svg": 94280,
	"./vocento.svg": 64914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40452;